export default __webpack_public_path__ + "static/media/bg-section-top-desktop-2.56f9794a.svg";